import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=90a9c068&scoped=true&"
import script from "./TextBlock.vue?vue&type=script&lang=js&"
export * from "./TextBlock.vue?vue&type=script&lang=js&"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=90a9c068&lang=scss&scoped=true&"
import style1 from "./TextBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a9c068",
  null
  
)

export default component.exports